// Basic API client for health data
// Restored for D11 baseline compatibility

export const healthAPI = {
  async getHealthData(userId: string, startDate: string, endDate: string) {
    try {
      const response = await fetch(`/api/health/${userId}?start=${startDate}&end=${endDate}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching health data:', error);
      throw error;
    }
  },

  async getCalendarData(month: number, year: number) {
    try {
      const token = localStorage.getItem('auth_token');
      // API expects 1-indexed months (1=Jan), but JavaScript uses 0-indexed (0=Jan)
      const response = await fetch(`/api/health/metrics/calendar?month=${month + 1}&year=${year}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching calendar data:', error);
      throw error;
    }
  },

  async submitHealthData(data: any) {
    try {
      const response = await fetch('/api/health', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error submitting health data:', error);
      throw error;
    }
  },

  async getGoals() {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch('/api/goals', {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching goals:', error);
      throw error;
    }
  }
};